var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNotFound = function SvgNotFound(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 259 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 240C186.274 240 240 186.274 240 120C240 53.7258 186.274 0 120 0C53.7258 0 0 53.7258 0 120C0 186.274 53.7258 240 120 240Z",
    fill: "url(#paint0_linear_37410_18647)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37410_18647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 42,
    width: 124.537,
    height: 155.029,
    rx: 16,
    fill: "url(#paint1_linear_37410_18647)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 62,
    width: 50,
    height: 9.8,
    rx: 4.9,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 89.7998,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 117.6,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 145.4,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 173.2,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 77C192.018 77 220 104.982 220 139.5C220 152.975 215.735 165.454 208.481 175.661L247.755 213.152L232.995 230.277L192.294 191.425C182.348 198.102 170.38 202 157.5 202C122.982 202 95 174.018 95 139.5C95 104.982 122.982 77 157.5 77ZM157.896 86.5869C128.672 86.587 104.982 110.277 104.982 139.5C104.982 168.723 128.672 192.413 157.896 192.413C187.119 192.413 210.809 168.723 210.809 139.5C210.809 110.277 187.119 86.5869 157.896 86.5869Z",
    fill: "#D1D9E1"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 95.3906,
    y: 77.4365,
    width: 125,
    height: 124
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_37410_18647_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 8,
    d: "M157.891 193.437C187.99 193.437 212.391 169.26 212.391 139.437C212.391 109.613 187.99 85.4365 157.891 85.4365C127.791 85.4365 103.391 109.613 103.391 139.437C103.391 169.26 127.791 193.437 157.891 193.437Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.992 230.279L247.752 213.154L249.975 215.276C252.132 217.335 253.424 220.212 253.565 223.273C253.707 226.334 252.688 229.329 250.731 231.6C248.774 233.87 246.041 235.229 243.132 235.378C240.224 235.527 237.378 234.454 235.22 232.395L232.997 230.273L232.992 230.279Z",
    fill: "#ADBFCB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37410_18647",
    x: 28,
    y: 32,
    width: 184.537,
    height: 215.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37410_18647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_37410_18647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_37410_18647_clip_path",
    transform: "translate(-95.3906 -77.4365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.891 193.437C187.99 193.437 212.391 169.26 212.391 139.437C212.391 109.613 187.99 85.4365 157.891 85.4365C127.791 85.4365 103.391 109.613 103.391 139.437C103.391 169.26 127.791 193.437 157.891 193.437Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37410_18647",
    x1: 119.075,
    y1: -39.0749,
    x2: 121.533,
    y2: 382.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37410_18647",
    x1: 120.269,
    y1: 42,
    x2: 120.269,
    y2: 197.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
};
export { SvgNotFound as ReactComponent };
export default __webpack_public_path__ + "static/media/NotFound.8efe83c0.svg";